
/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { SearchableItem, SearchableSelectionType } from './interface';
import { Naics } from './naics';

export class Sic implements SearchableItem {
  CODE: string;
  DESCRIPTION: string;
  SIC_NAICS: Naics[];

  // Helpers
  active = false;
  allowed = false;
  IS_DISABLED: boolean = false;

  constructor(value: any = {}) {
    Object.assign(this, value);

    if (value.SIC_NAICS) {
      this.SIC_NAICS = Naics.parseArray(value.SIC_NAICS);
    }
  }

  static parse(json: any): Sic {
    if (json) {
      const c = new Sic();

      c.CODE = json.CODE;
      c.DESCRIPTION = json.DESCRIPTION;
      c.SIC_NAICS = json.SIC_NAICS ? Naics.parseArray(json.SIC_NAICS) : [];

      return c;
    } else return null;
  }

  static parseArray(json: any[]): Sic[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new Sic(j));
        }
      }
    }

    return arr;
  }

  getName(): string {
    return this.DESCRIPTION;
  }

  getFullDetails(): string {
    return `${this.CODE} - ${this.DESCRIPTION}`;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }
}
